import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  useTheme,
} from '@mui/material';
import { Stack } from '@mui/system';
import { fetchPost } from '../api/common';
import { isMobile } from 'react-device-detect';

type PropTypes = {
  close: () => void;
  open: boolean;
  profileId: string;
};

export const SkillAssessmentDialog = ({
  close,
  open,
  profileId,
}: PropTypes) => {
  const theme = useTheme();

  const handleSkillClick = async (skill: number) => {
    const res = await fetchPost('/profile/skill-assessment', {
      profileId: profileId,
      skillAssessmentSelection: skill,
    });
    if (res.message) {
      close();
    }
  };

  return (
    <Dialog open={open} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Stack spacing={2}>
          <Typography variant="h4" textAlign={'center'}>
            One question before diving in
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Typography
          variant="h6"
          textAlign={'center'}
          mb={4}
          fontStyle={'italic'}
          sx={{ color: theme.palette.primary.main }}
        >
          Which one of these describe you the best?
        </Typography>
        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={4}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <Card sx={{ maxWidth: 345 }}>
            <CardActionArea onClick={() => handleSkillClick(1)}>
              <CardMedia
                component="img"
                height="300"
                image="https://res.cloudinary.com/dqlqwdqs9/image/upload/v1680069395/simpsons_iy5y9v.gif"
                alt="simpsons"
              />
              <CardContent>
                <Typography variant="h6" color="text.primary">
                  "I know the capital of Canada!... I think?"
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <Card sx={{ maxWidth: 345 }}>
            <CardActionArea onClick={() => handleSkillClick(2)}>
              <CardMedia
                component="img"
                height="300"
                image="https://res.cloudinary.com/dqlqwdqs9/image/upload/v1680069391/jason-segal-party_jgsfzb.gif"
                alt="jason"
              />
              <CardContent>
                <Typography variant="h6" color="text.primary">
                  "I dabble in bar trivia from time to time"
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <Card sx={{ maxWidth: 345 }}>
            <CardActionArea onClick={() => handleSkillClick(3)}>
              <CardMedia
                component="img"
                height="300"
                image="https://res.cloudinary.com/dqlqwdqs9/image/upload/v1680069342/dwight-schrute-screaming-dwight-schrute_lt1v3c.gif"
                alt="dwight"
              />
              <CardContent>
                <Typography variant="h6" color="text.primary">
                  "I yell at the TV when other people get stuff wrong"
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
